import React from 'react';

const VideoReview = () => {
  const scrollToOrder = () => {
    document.getElementById("order").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="bg-gradient-to-b from-green-900 to-green-700 py-16 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4 mb-4">
            <div className="bg-white/10 p-3 rounded-full backdrop-blur-sm border border-white/20 shadow-lg">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 sm:h-8 sm:w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white tracking-wide shadow-black/10 drop-shadow-md">
              আমাদের কাস্টমার কী বলছেন শুনুন
            </h2>
          </div>
          <p className="text-green-200 text-lg md:text-xl font-medium tracking-wide">
            বিশ্বাস করুন আমাদের সন্তুষ্ট কাস্টমারদের কথায়
          </p>
        </div>

        {/* Superior Premium Video Player */}
        <div className="max-w-3xl mx-auto mb-14 w-full px-4 lg:px-0">
          <div className="relative p-2 sm:p-4 bg-white/5 backdrop-blur-xl rounded-[2rem] border border-white/20 shadow-[0_0_50px_rgba(74,222,128,0.15)] group">
            {/* Soft background glow */}
            <div className="absolute -inset-4 bg-gradient-to-r from-green-400/20 to-emerald-500/20 blur-3xl opacity-50 group-hover:opacity-75 transition-opacity duration-700 -z-10 rounded-full"></div>
            
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-black ring-1 ring-white/10">
              <div className="absolute top-4 left-4 z-10 bg-black/50 backdrop-blur-md px-3 py-1.5 rounded-full border border-white/10 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shadow-[0_0_10px_rgba(239,68,68,0.8)]"></span>
                <span className="text-white text-xs font-semibold tracking-wider">LIVE REVIEW</span>
              </div>
              <video 
                className="w-full h-auto aspect-video object-cover opacity-95 group-hover:opacity-100 transition-opacity duration-500" 
                controls 
                preload="metadata" 
                playsInline
              >
                <source src="/videos/review-1.mp4" type="video/mp4" />
                Your browser does not support playing this video.
              </video>
            </div>
          </div>
        </div>

        {/* Trust Strip */}
        <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4 max-w-4xl mx-auto mb-14 px-2">
          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md rounded-xl px-5 py-3.5 text-white text-sm md:text-base font-semibold shadow-sm w-full sm:w-auto border border-white/10 hover:bg-white/20 transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-300 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <span>সত্যিকারের কাস্টমার রিভিউ</span>
          </div>
          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md rounded-xl px-5 py-3.5 text-white text-sm md:text-base font-semibold shadow-sm w-full sm:w-auto border border-white/10 hover:bg-white/20 transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-300 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            <span>কোনো স্ক্রিপ্ট নেই</span>
          </div>
          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md rounded-xl px-5 py-3.5 text-white text-sm md:text-base font-semibold shadow-sm w-full sm:w-auto border border-white/10 hover:bg-white/20 transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-300 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
            </svg>
            <span>সম্পূর্ণ সত্য অভিজ্ঞতা</span>
          </div>
        </div>

        {/* CTA Button */}
        <button
          onClick={scrollToOrder}
          className="relative group w-[90%] sm:w-full max-w-sm sm:max-w-md mx-auto block text-center rounded-xl transition-transform duration-300 hover:-translate-y-1"
        >
          {/* Base metallic gradient & shadow layer */}
          <div className="absolute inset-0 bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-600 rounded-xl shadow-[0_8px_20px_rgba(202,138,4,0.4)] sm:shadow-[0_10px_30px_rgba(202,138,4,0.5)] group-hover:shadow-[0_12px_25px_rgba(202,138,4,0.6)] sm:group-hover:shadow-[0_15px_40px_rgba(202,138,4,0.7)] transition-shadow duration-300"></div>
          
          {/* Metallic Top Glare */}
          <div className="absolute top-0 inset-x-0 h-1/2 bg-gradient-to-b from-white/60 to-transparent rounded-t-xl pointer-events-none"></div>
          
          {/* Bottom Reflection */}
          <div className="absolute bottom-0 inset-x-0 h-1/4 bg-gradient-to-t from-black/10 to-transparent rounded-b-xl pointer-events-none"></div>

          {/* Animated Shine Effect */}
          <div className="absolute inset-0 overflow-hidden rounded-xl">
             <div className="absolute inset-0 -translate-x-[150%] group-hover:translate-x-[150%] transition-transform duration-1000 ease-in-out bg-gradient-to-r from-transparent via-white/60 to-transparent w-full skew-x-[-20deg]"></div>
          </div>

          {/* Button Content */}
          <div className="relative flex items-center justify-center gap-2 sm:gap-3 py-3 sm:py-4 px-4 sm:px-6 border border-white/50 rounded-xl">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="w-5 h-5 sm:w-7 sm:h-7 text-green-900 drop-shadow-sm shrink-0">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
            </svg>
            <span className="text-green-900 font-extrabold text-[15px] sm:text-xl md:text-2xl tracking-wide drop-shadow-sm whitespace-nowrap">
              আমিও অর্ডার করতে চাই
            </span>
          </div>
        </button>

      </div>
    </section>
  );
};

export default VideoReview;
